import { render } from "./complete-coaches.vue?vue&type=template&id=5b7199ae"
import script from "./complete-coaches.vue?vue&type=script&lang=js"
export * from "./complete-coaches.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__